import { useContext, useEffect, useMemo, useRef, useState } from "react";
import axios, { AxiosRequestConfig } from "axios";

import Cookie from "js-cookie";
import authenticationContext from "../context/Authentication/AuthenticationContext.ts";

const DEVELOP_SERVER ="http://veterinary.tatdemo.ir/api/"
const MAIN ="http://veterinary.tatdemo.ir/api/"
export const URL = MAIN;


type ReturnType = {
  execute: (
    d?: { [key: string]: string | File } | FormData,
    newConfig?: AxiosRequestConfig
  ) => Promise<any>;
  cancel: () => void;
  loading: boolean;
  firstLoading: boolean;
};

const formDataMaker = (
  data: { [key: string]: string | File } | FormData
): FormData => {
  let fd: FormData;
  if (!(data instanceof FormData)) {
    fd = new FormData();
    if (typeof data !== "undefined") {
      Object.keys(data).forEach((key) => fd.append(key, data[key]));
    }
  } else {
    fd = data;
  }

  return fd;
};

const useAxios = (
  url: string,
  data?: { [key: string]: string | File } | FormData,
  configParams?: AxiosRequestConfig
): ReturnType => {
  const auth = useContext(authenticationContext);
  const controller = useRef<AbortController>(new AbortController());

  const [loading, setLoading] = useState<boolean>(false);

  const [counter, setCounter] = useState(0);

  const firstLoading = useMemo(() => counter !== 0, [counter]);

  const cancel = () => {
    controller.current.abort();
    setLoading(false);
    controller.current = new AbortController();
  };

  const execute = async (
    d?: { [key: string]: string | File } | FormData,
    newConfig?: AxiosRequestConfig
  ) => {
    let fd: FormData;
    if (typeof d !== "undefined") {
      fd = formDataMaker(d);
    } else if (typeof data !== "undefined") {
      fd = formDataMaker(data);
    } else {
      fd = new FormData();
    }

    let token = auth.isLogged ? Cookie.get("token") : Cookie.get("testToken");
    if (Cookie.get("token")) token = Cookie.get("token"); //shFazeli 1402/04/26
    else if (Cookie.get("testToken")) token = Cookie.get("testToken"); //shFazeli 1402/04/26
    // if (Cookie.get("token")) token ="ba68d1382a58515cba89dd9d07552625##2##1688577526"; //a.kia 14.2/04/29
    if (typeof token !== "undefined") {
      fd.append("usertoken", token);
    } else {
      fd.append(
        "usertoken",
        "undefined"
        // "OfcN*13*8V*12*J54tNkE3080OmJzeU1gra*12*nGON*13*Tt2jNqWQ7u2UUvUGN4mNVLy4SiJfL"
      );
    }

    let cp = { ...configParams };

    if (typeof newConfig !== "undefined") {
      cp = { ...cp, ...newConfig };
    }


    setLoading(true);
    return await axios
      .request({
        url,
        data: fd,
        signal: controller.current.signal,
        baseURL: URL, // Main Domain
        method: "POST",
        ...cp,
      })
      .then((res) => {
        setLoading(false);
        setCounter((prev) => prev + 1);
        return res.data;
      })
      .catch((err) => {
        setLoading(false);
        setCounter((prev) => prev + 1);
        return err;
      });
  };

  useEffect(() => {}, []);

  return { loading, execute, cancel, firstLoading };
};

export default useAxios;
